import React from 'react';
import { ActionIcon, Modal, Text, Stack, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconHelpOctagonFilled } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface GuidelinesHelpIconProps {
  title?: string;
  content?: string;
  resourcesPath?: string;
  size?: number;
  tooltipLabel?: string;
}

export const GuidelinesHelpIcon: React.FC<GuidelinesHelpIconProps> = ({
  title,
  content,
  resourcesPath = '/patientDashboard/resources',
  size = 50,
  tooltipLabel
}) => {
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure(false);

  // Default values from translations
  const modalTitle = title || t('guidelines.modalTitle');
  const modalContent = content || t('guidelines.biomarkersContent');
  const defaultTooltipLabel = tooltipLabel || t('guidelines.helpTooltip');

  const handleResourcesClick = () => {
    // Open Resources section in new tab as specified in the ticket
    window.open(resourcesPath, '_blank');
    close(); // Close modal after clicking link
  };

  return (
    <>
      <ActionIcon
        variant="subtle"
        c="blue"
        size={size}
        onClick={open}
        aria-label={defaultTooltipLabel}
        style={{ cursor: 'pointer' }}
      >
        <IconHelpOctagonFilled size={size * 0.7} />
      </ActionIcon>

      <Modal
        opened={opened}
        onClose={close}
        title={modalTitle}
        size="md"
        centered
      >
        <Stack gap="md">
          <Text size="sm" c="dimmed">
            {modalContent}
          </Text>

            <Button
              variant="outline"
              onClick={handleResourcesClick}
              size="sm"
            >
              {t('guidelines.visitResources')}
            </Button>
          
        </Stack>
      </Modal>
    </>
  );
}; 